import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ConnectedFormField from './ConnectedFormField';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormLayout from '../layout/useFormLayout';
import fieldsLogic from '../logic/fieldsLogic';
import Icon from '../../../../core/Icon';
import helpers from '../utils/fieldsHelper';

var ConnectedGroup = function ConnectedGroup(_ref) {
  var fieldId = _ref.fieldId;
  var fieldData = useFormDataLayer(fieldId);
  var layout = useFormLayout();
  var fieldContainer = layout.containers[fieldId];
  var dispatch = fieldData.dispatch,
      caption = fieldData.caption,
      collapsed = fieldData.collapsed;
  var showChildren = !collapsed; // move this into state

  var onToggle = function onToggle() {
    fieldsLogic.onMetaPropChanged(fieldId, 'collapsed', !collapsed, dispatch);
  };

  var descriptionContent = caption ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(caption)
    }
  }) : '';
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "flex-start",
    alignItems: "stretch",
    style: {
      borderLeft: '3px solid #E0E5EB',
      marginBottom: 20
    }
  }, React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    style: {
      backgroundColor: '#E0E5EB',
      paddingTop: 4,
      paddingBottom: 4,
      marginBottom: 5
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, {
    style: {
      color: 'black'
    },
    type: collapsed ? 'menu-right' : 'menu-down',
    onClick: onToggle,
    hoverable: true,
    buttonSize: "small"
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    style: {
      color: 'black'
    }
  }, descriptionContent))), showChildren && fieldContainer.rows && fieldContainer.rows.map(function (row, rowIdx) {
    return React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      key: row.id || rowIdx
    }, row.fields.map(function (field) {
      return React.createElement(Grid, {
        item: true,
        xs: field.size,
        key: field.id,
        className: "form-group"
      }, React.createElement(ConnectedFormField, {
        fieldId: field.id
      }));
    }));
  }));
};

export default React.memo(ConnectedGroup);